import { jsxAsElement as jsx } from 'web-shared/src/lib/jsx';
import { dataPointsEachSide, getTimeSeries } from './estrogen';

export class EstrogenLevels extends HTMLElement {
  timeSeries = getTimeSeries();

  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = '';

    const maxValue = this.timeSeries.reduce((a, b) =>
      b.level > a.level ? b : a,
    );

    this.append(
      <p>
        My current level is estimated @{' '}
        {this.timeSeries[dataPointsEachSide].level} pmol/L
      </p>,
      <div
        className="graph"
        data-key="Estrogen pmol/L by month (Live)"
        style={`--max-value: ${maxValue.level}`}
      >
        <div class="graphInner">
          {...this.timeSeries.map((data, i) => (
            <div
              className={`bar ${i === dataPointsEachSide ? 'solid' : ''}`}
              style={`--data: ${data.level}`}
            >
              {/* luxon `toFormat('yyyy LLL dd')`, e.g. "2026 Sep 12" */}
              {`${data.now.getFullYear()} ${data.now.toLocaleString('en', { month: 'short' })} ${String(data.now.getDate()).padStart(2, '0')}`}
            </div>
          ))}
        </div>
      </div>,
    );
  }
}
